import { combineReducers } from 'redux';
import auth from './auth';
import brands from './brands';
import reviews from './reviews';
import geoIp from './geo-ip';
import analytics from './analytics';
import fuelReport from './fuelReport';
import user from './user';
import preferences from './preferences';
import config from './config';
import contests from './contests';
import vehicleMakes from './vehicle-makes';
import vehicleModels from './vehicle-models';
import vehicleRecalls from './vehicle-recalls';
import vehicleProfile from './vehicle-profile';
import vehicles from './vehicles';
import offers from './offers';
import emergencyStatusHistory from './emergency-history';
import marketing from './marketing';
import ubi from './ubi';
import geo from './geo';
import membership from './membership';
import fuelLogs from './fuelLogs';
import fuelEconomyStats from './fuelEconomyStats';
import home from './home';
import cms from './cms';

export default combineReducers({
  auth,
  brands,
  reviews,
  geoIp,
  analytics,
  fuelReport,
  user,
  preferences,
  config,
  contests,
  geo,
  vehicleMakes,
  vehicleModels,
  vehicleRecalls,
  vehicleProfile,
  vehicles,
  offers,
  emergencyStatusHistory,
  marketing,
  ubi,
  membership,
  fuelLogs,
  fuelEconomyStats,
  home,
  cms,
});
